export default __webpack_public_path__ + "static/card-back-3-893f0516d567e70efcb14afba60c1b64.png";